<mat-list class="zwi-card-section">
  @for (sermon of sermons; track sermon.id) {
    <zwi-sermon [bookmarkable]="bookmarkable" [sermon]="sermon" (starChange)="onStarChange($event)"></zwi-sermon>
  }
</mat-list>

